import { UseFormReset, UseFormSetFocus, UseFormSetValue } from 'react-hook-form';
import { Contact } from '../../../components/address-book';
import { useInitializationDataContext } from '../../../context/data-context';
import { AddressForm, AddressTypes } from '../../../global-types';
import { useEnvelopeSelection } from '../../select-envelope/hooks/use-envelope-selection';
import { getDefaultAddressOptions } from '../utils/get-default-address-options';

export const useNavigationBack = () => {
  const {
    initializedDataState: { isUK },
  } = useInitializationDataContext();
  const { selectedEnvelope } = useEnvelopeSelection();

  const contactAtIndex = (contacts: Contact[], index: number): Contact | undefined => {
    if (index >= 0 && index < contacts.length) {
      return contacts.at(index);
    }
    return undefined;
  };

  const assignForm = (
    contact: Contact | undefined | null,
    handleSetFormValue: UseFormSetValue<AddressForm>,
    handleSetFocus: UseFormSetFocus<AddressForm>,
    handleResetFormAddresses: UseFormReset<AddressForm>,
  ) => {
    const options = { shouldValidate: true, shouldDirty: true };
    if (contact) {
      handleSetFormValue('first_name', contact.first_name, options);
      handleSetFormValue('last_name', contact.last_name, options);
      handleSetFormValue('display_name', contact.display_name, options);
      handleSetFormValue('address_line_1', contact.address_line_1, options);
      handleSetFormValue('address_line_2', contact.address_line_2, options);
      handleSetFormValue('city', contact.city, options);
      handleSetFormValue('state_code', contact.state_code, options);
      handleSetFormValue('zip', contact.zip, options);
      handleSetFormValue('country_code', contact.country_code, options);

      handleSetFocus('first_name');
      return;
    }

    handleResetFormAddresses(
      getDefaultAddressOptions({
        isUK,
        selectedEnvelope,
        currentAddressType: AddressTypes.RECIPIENT,
        skipUspsValidation: true,
      }),
      {
        keepDirty: false,
        keepIsValid: false,
      },
    );
  };

  return {
    contactAtIndex,
    assignForm,
  };
};
